import { render, staticRenderFns } from "./PadoNPCComponent.vue?vue&type=template&id=7008f42e&scoped=true"
import script from "./PadoNPCComponent.vue?vue&type=script&lang=ts"
export * from "./PadoNPCComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoNPCComponent.vue?vue&type=style&index=0&id=7008f42e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008f42e",
  null
  
)

export default component.exports